var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState, useEffect, useRef } from 'react';
import { Col, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { TypeSelected, ShowButtons, PurchasePriceUpdate, DownPaymentInUSDsUpdate, estimatedValueUpdate, loanBalanceUpdate, cashoutAmountUpdate } from "../store/actions";
import imgPurchase from '../assets/Asset 1.jpg';
import imgRefinance from '../assets/Asset 2.jpg';
import imgCashOut from '../assets/Asset 3.jpg';
import { UserSession } from 'usersession';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function

export default function LoanPurpose() {
    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        loanPurpose = _useState2[0],
        setLoanPurpose = _useState2[1];

    var dispatch = useDispatch();
    var loanPurposeRedux = useSelector(function (state) {
        return state.nameReducer.type;
    });
    var userSession = new UserSession();

    var myRefLP = useRef(null);

    useEffect(function () {
        //This function scroll the slider into view
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefLP);
    }, []);

    useEffect(function () {
        /* Initialize the custom quote navigation as this is the first page.
        Many other elements on the page will depend on this flag to perform different actions.
        */
        dispatch(ShowButtons(true));
        userSession.setCustomQuote(true);

        setLoanPurpose(loanPurposeRedux);

        userSession.setLoanPurpose(loanPurposeRedux);

        if (loanPurpose.length > 0) {
            dispatch(ShowButtons(true));
            if (loanPurpose === "FULL DOCS REFI" || loanPurpose === "CASH OUT REFI") {
                dispatch(PurchasePriceUpdate(0));
                dispatch(DownPaymentInUSDsUpdate(0));
                userSession.setPurchasePrice(0);
                userSession.setDownPaymentAmount(0);
                userSession.setCashOutAmount(0); //This is only for the Refi case if the user selected cashout the value will be modify.    
            }

            if (loanPurpose === "PURCHASE") {
                dispatch(estimatedValueUpdate(0));
                dispatch(loanBalanceUpdate(0));
                dispatch(cashoutAmountUpdate(0));
                userSession.setEstimatedValue(0);
                userSession.setCurrentLoanBalance(0);
                userSession.setCashOutAmount(0);
            }
        }
    }, [loanPurpose]);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            Form.Group,
            { className: 'mb-0' },
            React.createElement(
                Form.Row,
                { className: 'pt-1 d-flex justify-content-center' },
                React.createElement(
                    Col,
                    { xs: 10, sm: 10, md: 11, lg: 12, className: 'text-center mb-3 pb-1' },
                    React.createElement(
                        'h2',
                        null,
                        'What loan purpose would you like to look into?'
                    )
                ),
                React.createElement(
                    Col,
                    { sm: 12, lg: 1, className: 'd-none d-sm-none d-md-none d-lg-flex align-items-center justify-content-center pb-2 pb-sm-2 pb-md-0 mb-4' },
                    React.createElement(
                        Button,
                        { className: 'backToHome', onClick: function onClick() {
                                return window.location.reload(false);
                            } },
                        "<<"
                    )
                ),
                React.createElement(
                    Col,
                    { ref: myRefLP, lg: 3, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'loanPurchase',
                            name: 'loanPurchase',
                            value: 'PURCHASE',
                            'aria-label': 'Purchase',
                            label: 'Purchase',
                            checked: loanPurpose === "PURCHASE",
                            onChange: function onChange(e) {
                                setLoanPurpose(e.target.value);dispatch(TypeSelected(e.target.value));
                            } }),
                        React.createElement('img', { src: imgPurchase,
                            alt: 'Purchase Home',
                            className: 'radImg2 rounded-circle radImg customShadow \n                            ' + (loanPurpose === "PURCHASE" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Purchase'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 3, className: 'mb-4' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            id: 'loanFullDocsRefi',
                            name: 'loanFullDocsRefi',
                            inline: true,
                            value: 'FULL DOCS REFI',
                            label: 'Refi',
                            'aria-label': 'Refi',
                            checked: loanPurpose === "FULL DOCS REFI",
                            onChange: function onChange(e) {
                                setLoanPurpose(e.target.value);dispatch(TypeSelected(e.target.value));
                            } }),
                        React.createElement('img', { src: imgRefinance, alt: 'Refinance Home', className: 'radImg2 rounded-circle radImg customShadow ' + (loanPurpose === "FULL DOCS REFI" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Refinance'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 3, className: 'mb-2' },
                    React.createElement(
                        'div',
                        { className: 'overlay' },
                        React.createElement(Form.Check, {
                            type: 'radio',
                            inline: true,
                            id: 'loanCashOut',
                            name: 'loanCashOut',
                            value: 'CASH OUT REFI',
                            'aria-label': 'Cash Out Refi',
                            label: 'Cash Out Refi',
                            checked: loanPurpose === "CASH OUT REFI",
                            onChange: function onChange(e) {
                                setLoanPurpose(e.target.value);dispatch(TypeSelected(e.target.value));
                            } }),
                        React.createElement('img', { src: imgCashOut, alt: 'Cash out Home', className: 'radImg2 rounded-circle radImg customShadow ' + (loanPurpose === "CASH OUT REFI" ? "d-none" : "") })
                    ),
                    React.createElement(
                        'h4',
                        null,
                        'Cash Out Refi'
                    )
                )
            )
        ),
        React.createElement(
            Button,
            { className: 'd-inline d-sm-inline d-md-inline d-lg-none float-left backToHome', onClick: function onClick() {
                    return window.location.reload(false);
                } },
            "<<"
        )
    );
}